import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { actualizarMedico } from "../../services/medicoService";

const ModalEditarMedico = ({
                               show,
                               onHide,
                               medico,
                               onMedicoActualizado
                           }) => {
    const [medicoEdit, setMedicoEdit] = useState({});

    // Actualizar el estado cuando cambia el médico
    useEffect(() => {
        if (medico) {
            setMedicoEdit({ ...medico });
        }
    }, [medico]);

    const handleActualizarMedico = async () => {
        if (!medicoEdit.nombre?.trim() || !medicoEdit.apellido?.trim()) {
            toast.warning("⚠️ Debe completar nombre y apellido.");
            return;
        }

        if (medicoEdit.telefono && !/^\d{8,15}$/.test(medicoEdit.telefono)) {
            toast.warning("⚠️ El teléfono debe contener solo números (8 a 15 dígitos).");
            return;
        }

        try {
            await actualizarMedico(medicoEdit.idMedico, {
                ...medicoEdit,
                telefono: medicoEdit.telefono ? Number(medicoEdit.telefono) : null,
            });

            toast.success("✅ Médico actualizado correctamente");
            onHide();
            if (onMedicoActualizado) {
                onMedicoActualizado(medicoEdit);
            }
        } catch (err) {
            console.error(err);
            toast.error("❌ No se pudo actualizar el médico.");
        }
    };

    const handleClose = () => {
        setMedicoEdit({});
        onHide();
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Editar datos del médico</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-light">
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Nombre</Form.Label>
                        <Form.Control
                            value={medicoEdit.nombre || ""}
                            onChange={(e) => setMedicoEdit({ ...medicoEdit, nombre: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Apellido</Form.Label>
                        <Form.Control
                            value={medicoEdit.apellido || ""}
                            onChange={(e) => setMedicoEdit({ ...medicoEdit, apellido: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Matrícula</Form.Label>
                        <Form.Control
                            value={medicoEdit.matricula || ""}
                            onChange={(e) => setMedicoEdit({ ...medicoEdit, matricula: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Especialidad</Form.Label>
                        <Form.Control
                            value={medicoEdit.especialidad || ""}
                            onChange={(e) => setMedicoEdit({ ...medicoEdit, especialidad: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control
                            type="tel"
                            value={medicoEdit.telefono || ""}
                            onChange={(e) => setMedicoEdit({ ...medicoEdit, telefono: e.target.value })}
                            placeholder="Ej: 1123456789"
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="bg-light">
                <Button variant="secondary" onClick={handleClose}>
                    Cancelar
                </Button>
                <Button variant="primary" onClick={handleActualizarMedico}>
                    Guardar cambios
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalEditarMedico;